import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-cwhp',
  templateUrl: './cwhp.component.html',
  styleUrls: ['./cwhp.component.css']
})
export class CwhpComponent implements OnInit {

    public orderStatus        : any = AppSettings.orderStatus;
    public writersRegion      : any = AppSettings.writersRegion;
    public loading            : any = false;
    public paginatePage       : any;
    public leads              : any = [];
    public leads_Copy         : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];
    public emailCheckBoxArr   : any = [];

    public addCommentForm     : FormGroup;
    public submitted          : any = false;

    public posIndex           : any;
    public posVal             : any;
    public positions          : any = [
                                        { name:'All Positions', value: 'all' },
                                        { name:'No Position',   value: '0' },
                                        { name:'On Query',      value: '1' },
                                        { name:'On Hold',       value: '2' }
                                      ];

    public positionStatus          : any = [
                                        { name:'New Order',     value: 0 },
                                        // { name:'No Position',   value: '0' },
                                        { name:'On Query',      value: 1 },
                                        { name:'On Hold',       value: 2 }
                                      ];

    public verifyOrNot        : any = [
                                        { name: 'Verified / Unverified', value: '' },
                                        { name: 'Verified',              value: '1' },
                                        { name: 'Unverified',            value: '2' }
                                      ];
    public agentsSub          : any;
    public agents             : any;
    public qa                 : any;
    public loader             : any;

    @ViewChild(DataTableDirective)
    public dtElement    : DataTableDirective;
    public dtOptions    : DataTables.Settings = {};
    public dtTrigger    : any = new Subject();

    public searchParams  : any =  { order_id : '', date_from: '', date_to:'' };
    public fullRangeDate : any;
    public selectedDesposition     : any;
    public writers                 : any;
    public all_users               : any;
    public lead_id_Verify          : any;
    public lead_Verify_index       : any;
    public lead_status             : any;
    public notes                   : any;
    public addingNote              : any = false;
    public addNoteId               : any;
    public addNoteIndex            : any;
    public sendingEmail            : any = false;
    public base64Pipe              : any = new Base64Pipe;
    public checkedText             : any = 0;
    public stLoader1               : any = false;
    public stLoader2               : any = false;
    public checkBoxAll             : any = 0;
    public floatingAlert           : any = true;

    constructor(
      private helperService        : HelperService,
      private agentsService        : Agents,
      private formBuilder          : FormBuilder,
    ) {

        // Get Agents
        this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
          if (agents) {
            this.agents     = agents.agents;
            this.qa         = agents.qa;
            this.writers    = agents.writers;
            this.all_users  = agents.all_users;
          }
        });

        this.dtOptions = {
          paging: true,
          info: true,
          // ordering: false,
          pagingType: 'full_numbers',
          pageLength: 10,
          serverSide: true,
          processing: true,
          searching: false,
          'language': AppSettings.dataTableLang,
          "columnDefs": [
            { "orderable": false,                           "targets": 0 },
            { "orderable": false,                           "targets": 1 },
            { "orderable": false,                           "targets": 2 },
            { "orderable": false,                           "targets": 3 },
            { "orderable": false,                           "targets": 4 },
            { "orderable": false,                           "targets": 5 },
            { "orderable": true,                            "targets": 6 },
            { "orderable": false,                           "targets": 7 },
            { "orderable": false,                           "targets": 8 },
            { "orderable": false,                           "targets": 9 },
            { "orderable": false,                           "targets": 10 },
          ],
          "order": [[ 6, "desc" ]],
          ajax: (dataTablesParameters: any, callback) => {
            // Show Loader
            this.loading = true;
            // console.log("dataTablesParameters", dataTablesParameters);

            let url  = AppSettings.API_ENDPOINT + 'support/get-cwhp-orders';

            let dtParams = {
                            lead                 : this.searchParams.order_id,
                            date_from            : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                            date_to              : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                            start                : dataTablesParameters.start,
                            length               : dataTablesParameters.length,
                            order                : dataTablesParameters.order,
                            columns              : dataTablesParameters.columns
                          };

            // For Record Serial Numbers
            this.paginatePage = dataTablesParameters.start;
            this.leads.data = [];
            this.helperService.httpPostRequestsDecryp(url, dtParams)
              .then( resp => {
                  this.leads        = JSON.parse(resp);
                  this.leads_Copy   = $.extend(true, {}, this.leads);

                  // console.log("this.leads", this.leads);

                  // Set Default page len
                  this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                  // Hide Loader
                  this.loading = false;

                  callback({
                    recordsTotal: this.leads.total,
                    recordsFiltered: this.leads.total,
                    // recordsFiltered: resp['recordsFiltered'],
                    // recordsFiltered: 1000,
                    data: []
                  });

                  // // $(".paginate_button .current").css("color", "white");
                  // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                  $('div.dataTables_length select').addClass('dt-form-control');
                  $('div.dataTables_filter input').addClass('dt-form-control');
              })
              .catch(error => {
                  // Set loader false
                  this.loading = false;

                  // // Rerender DT in case of failure
                  // this.rerender();

                  console.log("error: ",error);
              });
          },
          columns: [
            { data: 'multiSelect' },
            { data: 'sr' },
            { data: 'order_id' },
            { data: 'timestamp' },
            { data: 'client_info' },
            { data: 'price_noOfPages' },
            { data: 'delivery_date' },
            { data: 'academic_level' },
            { data: 'writerDD' },
            { data: 'textMessage' },
            { data: 'notes' },
          ],
          // Use this attribute to enable the responsive extension
          responsive: false
        }

    }

    ngOnInit() {
        this.addCommentForm = this.formBuilder.group({
          comment: [null, Validators.required],
        });
    }

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();

      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
        }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate){
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }
      this.rerender();
    }

    showNotes(lead, index) {
        this.submitted = false;
      // Show Loader
      this.leads.data[index].gettingNotes = true;

      this.addNoteId    = lead.id;
      this.addNoteIndex = index;
      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o: lead.id, type : 'MY-CWHP'};
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments = resp;
          }

          $("#notesModal").modal("show");

          // Hide Loader
          this.leads.data[index].gettingNotes = false;
      }).catch(err => {
          // Hide Loader
          this.leads.data[index].gettingNotes = false;
      });
    }

    get f() { return this.addCommentForm.controls; }

    addNotes() {
        // Set Submission True
        this.submitted = true;

        // Stop here if form is invalid
        if (this.addCommentForm.invalid) {
          return;
        }
      // Show Loader
      this.addingNote = true;

      let url = AppSettings.API_ENDPOINT + "shared/insert-note";
      let data = { id: this.addNoteId, note : this.notes, type : 'MY-CWHP' };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
              this.notes = "";
              this.leads.data[this.addNoteIndex].view_notes = true;
              $("#notesModal").modal("hide");
              Swal.fire('', resp.message , 'success');
          }

          // Hide Loader
          this.addingNote = false;
      }).catch(err => {
          // Hide Loader
          this.addingNote = false;
      });
    }

    showVrfModal(index, checkedText = 0){
        this.checkedText = 0;
        if(typeof $ != "undefined") {
            this.checkedText = checkedText;
            $("#sendText_modal" + index).modal("show");
        }
        $(".modal-backdrop").click(function(){
          $("#sendText_modal" + index).modal("hide");
        });
    }

    sendText(lead, index) {
        $("#sendText_modal" + index).modal("hide");
        $(".modal-backdrop").remove();

        let url = AppSettings.API_ENDPOINT + "support/send-cwhp-sms";
        let data = { oid : lead.id, txtType: this.checkedText };

        if(this.checkedText == 1) {
            this.leads.data[index].stLoader1 = true;
        }
        else if(this.checkedText == 2){
            this.leads.data[index].stLoader2 = true;
        }

        this.helperService.httpPostRequests(url,data).then(resp => {
            if(typeof resp != "undefined" && resp.status == "OK") {
                if(this.checkedText == 1)
                {
                    this.leads.data[index].cwhp_text_1 = 1;
                    this.leads.data[index].cwhp_text_1_date = resp.data.date;
                    this.leads.data[index].cwhp_text_1_writer_name = resp.data.name;
                    this.leads.data[index].textSent1 = true;
                    setTimeout(() => {
                        this.leads.data[index].textSent1 = '';
                    }, 1000);
                }
                else if(this.checkedText == 2)
                {
                    this.leads.data[index].cwhp_text_2 = 1;
                    this.leads.data[index].cwhp_text_2_date = resp.data.date;
                    this.leads.data[index].cwhp_text_2_writer_name = resp.data.name;
                    this.leads.data[index].textSent2 = true;
                    setTimeout(() => {
                        this.leads.data[index].textSent2 = '';
                    }, 1000);
                }
            }

            if(typeof resp != "undefined" && resp.status == "ERROR") {
              Swal.fire('', resp.message , 'error');
            }

            // Hide Loader
            this.leads.data[index].stLoader1 = false;
            this.leads.data[index].stLoader2 = false;
        }).catch(err => {
            // Hide Loader
            this.leads.data[index].stLoader1 = false;
            this.leads.data[index].stLoader2 = false;
        });


    }

    selectCust(lead){
        if(lead.checkbox)
            this.emailCheckBoxArr.push(lead.id);
        else
            this.emailCheckBoxArr.splice(this.emailCheckBoxArr.indexOf(lead.id), 1);


    }

    selectAllCust(){
        this.emailCheckBoxArr = [];
        this.leads.data.forEach(lead => {
            if(this.checkBoxAll)
            {
                if(!lead.already_sent_email_single)
                {
                    lead.checkbox = 1;
                    this.emailCheckBoxArr.push(lead.id);
                }
            }
            else
                lead.checkbox = 0;
        });
    }

    sendEmailsToCust() {
      // Hide modal
      $("#sendEmailModal").modal("hide");

      if(this.emailCheckBoxArr.length == 0){
          Swal.fire('', 'No Order selected' , 'error');
          return;
      }

      // Show loader
      this.sendingEmail = true;

      let url = AppSettings.API_ENDPOINT + "support/send-cwhp-email";
      let data = { oids: this.emailCheckBoxArr };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
              this.leads.already_sent_email_all = true;
              this.leads.data.forEach(lead => {
                    this.checkBoxAll = 0;
                    lead.checkbox = 0;
                    if(this.emailCheckBoxArr.includes(lead.id))
                        lead.already_sent_email_single = true;
                    if(lead.already_sent_email_single == false)
                        this.leads.already_sent_email_all = false;
              });
            Swal.fire('', resp.message , 'success');
          }
          if(typeof resp != "undefined" && resp.status == "ERROR") {
            Swal.fire('', resp.message , 'error');
          }

          // Hide loader
          this.sendingEmail = false;
      }).catch(err => {
          // Hide loader
          this.sendingEmail = false;
      });
    }
    closeFloatingAlert(){
        this.floatingAlert = false;
    }

    agentSearch(id, agentArr) {

      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }
    }

    clearFilters(){
      this.searchParams = { order_id: '', date_from: '', date_to:''};
      this.fullRangeDate = "";

      this.rerender();
    }

}
